import { Card, Form, Input, Select } from 'antd';
import { EcommerceIconComponent } from 'assets/icons/ecommerce';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { IProduct } from 'interfaces/products';
import { IProductSet } from 'interfaces/product_sets';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm, useSelect } from '@refinedev/antd';

export const ProductSetEdit = () => {
  const { formProps, saveButtonProps } = useForm<IProductSet>({
    redirect: 'edit'
  });

  const { selectProps } = useSelect<IProduct>({
    resource: 'products',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });

  return (
    <EditLayout saveButtonProps={saveButtonProps} title="Editar set">
      <PageHeader
        title={formProps.initialValues?.name}
        icon={EcommerceIconComponent}
      />

      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item label="Nome" name="name">
            <Input />
          </Form.Item>
          <Form.Item label="Produtos" name="product_ids">
            <Select {...selectProps} allowClear mode="multiple" />
          </Form.Item>
        </Form>
      </Card>
    </EditLayout>
  );
};
